import { RootState } from "redux-store";
import { GameStatus } from "./game.interfaces";
import { createSelector } from "@reduxjs/toolkit";

export const getChosenLevel = (state: RootState) =>
  state?.game?.chosenLevel ?? null;
export const getRotations = (state: RootState) => state?.game?.rotations ?? [];
export const getTileRotation = (index: number) =>
  createSelector(getRotations, (rotations) => rotations[index]);
export const getGameStatus = (state: RootState) =>
  state?.game?.status ?? GameStatus.RESET;
export const getRemainingTime = (state: RootState) =>
  state?.game?.remainingTime ?? 0;
export const getTotalMoves = (state: RootState) => state?.game?.totalMoves ?? 0;
export const getIsTimerFrozen = (state: RootState) =>
  state?.game?.isTimerFrozen ?? false;
export const getFreezeTimePowerUsed = (state: RootState) =>
  state?.game?.freezeTimePowerUsed ?? false;
export const getFixTilePowerUsed = (state: RootState) =>
  state?.game?.fixTilePowerUsed ?? false;
